// extracted by mini-css-extract-plugin
export default {"formFooter":"FormFooter_formFooter__2XGnz"};